import { axiosBaseQuery } from 'react-common'
import { request } from 'react-common'
import { createApi } from '@reduxjs/toolkit/query/react'

const ENDPOINT = 'users/me/terms'

export type Term = { id: string; name: string }

export const termsApi = createApi({
  reducerPath: 'termsApi',
  baseQuery: axiosBaseQuery(request),
  tagTypes: ['Term'],
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  endpoints: (builder) => ({
    getTerms: builder.query<Term[], void>({
      query: () => ({ url: ENDPOINT, method: 'get' }),
      providesTags: (result) =>
        result ? ['Term', ...result.map(({ id }) => ({ type: 'Term' as const, id }))] : ['Term'],
    }),
  }),
})

export const { useGetTermsQuery } = termsApi
